module.exports = __webpack_public_path__ + "static/media/playfair-display-latin-400-normal.d0318390.woff";